import {combineReducers} from "redux";
import eventsReducer from "./eventsReducer";
import statsReducer from "./statsReducer";
import usersReducer from "./usersReducer";

export const rootReducer = combineReducers({
    eventsReducer,
    statsReducer,
    usersReducer
});